<div class="col-12 mt-3">
  <h6>Gerenciamento de Entidades</h6>
<nz-transfer
      [nzDataSource]="list"
      nzShowSearch
      [nzListStyle]="{ 'width.vw': 50, 'height.vh': 30 }"
      [nzFilterOption]="filterOption"
      (nzChange)="change($event)"
    ></nz-transfer>
</div>
